import Vue, { CreateElement } from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class ClAvatar extends Vue {
  @Prop({
    type: String,
    default: 'div'
  })
  readonly component!: string;

  @Prop(String)
  readonly src!: string;

  @Prop(String)
  readonly alt!: string;

  @Prop(String)
  readonly sizes!: string;

  @Prop(String)
  readonly srcSet!: string;

  @Prop(Object)
  readonly imgProps!: object;

  render(h: CreateElement) {
    const Component = this.component;
    return (
      <Component class="cl-avatar" {...{ on: this.$listeners }}>
        {this.src ? <img src={this.src} alt={this.alt} /> : this.$slots.default}
      </Component>
    );
  }
}
